import { c as _c } from "react/compiler-runtime";
import { ProgressBar, ProgressBarLabel } from '@7f-ui/components/progress-bar/progress-bar';
import { Star } from '@7f-ui/components/star-rating/star';
import { Fragment } from 'react';
import { TrustedStars } from './trusted-stars';
type RatingBreakdownProps = {
  breakdown: readonly number[];
  totalReviews: number;
  variant: 'single-star' | 'five-stars';
};
export function RatingBreakdown(t0) {
  const $ = _c(8);
  const {
    breakdown,
    totalReviews,
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [5, 4, 3, 2, 1];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== breakdown || $[2] !== totalReviews) {
    t2 = t1.map((stars, index) => ({
      stars,
      percentage: totalReviews ? Math.round((breakdown[index] ?? 0) / totalReviews * 100) : 0
    }));
    $[1] = breakdown;
    $[2] = totalReviews;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const rows = t2;
  if (variant === "single-star") {
    let t3;
    if ($[4] !== rows) {
      t3 = <div className="grid grid-cols-[2ch_1fr_4ch] gap-2">{rows.map(_temp)}</div>;
      $[4] = rows;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== rows) {
    t3 = <div className="flex flex-col gap-2">{rows.map(_temp2)}</div>;
    $[6] = rows;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp2(t0) {
  const {
    stars: stars_1,
    percentage: percentage_0
  } = t0;
  return <div key={stars_1} className="flex w-full items-center gap-4 whitespace-nowrap"><div className="flex items-center gap-1"><TrustedStars rating={stars_1} direction="rtl" /></div><ProgressBar value={percentage_0} max={100} type="inline" className="flex-1"><ProgressBarLabel className="inline-block w-10 text-left font-body-copy text-primary">{percentage_0} %</ProgressBarLabel></ProgressBar></div>;
}
function _temp(t0) {
  const {
    stars: stars_0,
    percentage
  } = t0;
  return <Fragment key={stars_0}><div className="flex items-center gap-0.5"><span className="font-base-copy text-secondary-text">{stars_0}</span><Star className="size-3 text-primary" /></div><ProgressBar value={percentage} max={100} type="inline" className="min-w-0 flex-1" /><ProgressBarLabel className="justify-self-end font-base-copy">{percentage} %</ProgressBarLabel></Fragment>;
}